import React, { useEffect, useState } from 'react';
import { FiBell } from 'react-icons/fi';

const Ticker = () => {
  const [texts, setTexts] = useState([]);
  const [color, setColor] = useState('#2f7690');

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const res = await fetch('https://us-central1-indian-park.cloudfunctions.net/getHomepageBanner');
        const data = await res.json();
        if (data?.texts?.length) {
          setTexts(data.texts);
          setColor(data.color || '#2f7690');
        }
      } catch (err) {
        console.error('Failed to load banner config:', err);
      }
    };

    fetchBanner();
  }, []);

  return (
    texts.length > 0 ? (
      <div className="announcement-bar" role="status" style={{ backgroundColor: color }}>
        <FiBell aria-hidden="true" />
        <strong>Community notice</strong>
        <span>{texts.join(' · ')}</span>
      </div>
    ) : null
  );
};

export default Ticker;
